// eslint-disable-next-line import/no-restricted-paths
import isEqual from "lodash.isequal";

import type { S3Object } from "@/lib/gql/__generated__/graphql";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

import type { ProductDayTripPlanFormModel } from "../../../../../../model/type";

export const useDayTripPlanKeyVisual = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { mainKeyVisual, keyVisuals } = viewModel;

	const isEditedMainKV = !isEqual(mainKeyVisual, DUMMY_IMAGE.s3Object);
	const hasErrorMainKV =
		Boolean(mainKeyVisual.bucket.error) ||
		Boolean(mainKeyVisual.key.error) ||
		Boolean(mainKeyVisual?.mimeType?.error) ||
		Boolean(mainKeyVisual?.fileName?.error) ||
		Boolean(mainKeyVisual?.region.error) ||
		false;
	const errorMessageMainKV =
		mainKeyVisual.bucket.error ||
		mainKeyVisual.key.error ||
		mainKeyVisual.mimeType?.error ||
		mainKeyVisual.fileName?.error ||
		mainKeyVisual.region.error;

	const onSetMainKeyVisual = (value: S3Object | null) => {
		const s3Object = value;

		const newMainKeyVisual = {
			key: {
				isEdited: true,
				value: s3Object?.key ?? "",
			},
			bucket: {
				isEdited: true,
				value: s3Object?.bucket ?? "",
			},
			mimeType: {
				isEdited: true,
				value: s3Object?.mimeType ?? "",
			},
			fileName: {
				isEdited: true,
				value: s3Object?.fileName ?? "",
			},
			region: {
				isEdited: true,
				value: s3Object?.region ?? "",
			},
		} satisfies ProductDayTripPlanFormModel["ViewModel"]["mainKeyVisual"];

		onSetViewModel([
			{
				key: "mainKeyVisual",
				value: newMainKeyVisual,
			},
		]);
	};

	const onSetKeyVisuals = (value: S3Object[]) => {
		const newKeyVisualsValue = value.map((v) => {
			return {
				key: {
					isEdited: true,
					value: v.key,
				},
				bucket: {
					isEdited: true,
					value: v.bucket,
				},
				mimeType: {
					isEdited: true,
					value: v.mimeType,
				},
				fileName: {
					isEdited: true,
					value: v.fileName,
				},
				region: {
					isEdited: true,
					value: v.region,
				},
			} satisfies ProductDayTripPlanFormModel["ViewModel"]["keyVisuals"]["value"][0];
		});

		const newMainKeyVisuals = {
			isEdited: true,
			hasError: false,
			value: newKeyVisualsValue,
		} satisfies ProductDayTripPlanFormModel["ViewModel"]["keyVisuals"];

		onSetViewModel([{ key: "keyVisuals", value: newMainKeyVisuals }]);
	};

	return {
		mainKeyVisual,
		isEditedMainKV,
		hasErrorMainKV,
		errorMessageMainKV,
		onSetMainKeyVisual,

		keyVisuals,
		onSetKeyVisuals,
	};
};
